import { render, staticRenderFns } from "./queryOrder.vue?vue&type=template&id=60762593&scoped=true"
import script from "./queryOrder.vue?vue&type=script&lang=js"
export * from "./queryOrder.vue?vue&type=script&lang=js"
import style0 from "./queryOrder.vue?vue&type=style&index=0&id=60762593&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60762593",
  null
  
)

export default component.exports